import DownloadPurpose from "@/utils/constants/DownloadPurpose.ts";
import Translator from "@/utils/common/Translator.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import EntityReferenceData = namaTypes.EntityReferenceData;

export default class AttachmentLinkUtil
{
  static downloadURLByRecordId(ref: EntityReferenceData, purpose: DownloadPurpose, redirect: boolean, itemCode?: string) {
    return this.downloadURL("recordId", ref.id!, ref.entityType!, purpose, redirect, false, itemCode);
  }

  static downloadURL(idParamName: string, id: string, entityType: string, purpose: DownloadPurpose, redirect: boolean, noCache: boolean, itemCode?: string) {
    let redirectVal = "&redirect=" + redirect;
    if (redirect)
      redirectVal = "";
    let url = "file.download?" + idParamName + "=" + id + (itemCode != null ? "&itemCode=" + itemCode : "") + (purpose != null ? "&purpose=" + purpose : "") + redirectVal + "&entitytype="
      + entityType + "&locale=" + (Translator.isArabic() ? "ar" : "en") + (noCache ? "&nocahce=" + ClientCache.currentTimeMillis() : "");
    return url;
  }
}
